import CtrlTipoSolicitacao from './pages/CtrlTipoSolicitacaoPage.vue'

const routes = [
  {
    path: 'ctrl-tipos-solicitacao',
    name: 'ctrl-tipos-solicitacao',
    component: CtrlTipoSolicitacao
  }
];

export default routes;